module.exports = __webpack_public_path__ + "img/carpark_pay_pin_selected.75388d45.png";